export const FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED = 'FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED'
export const FINALIZE_PROJECT_SUCCEEDED = 'FINALIZE_PROJECT_SUCCEEDED'
export const REOPEN_PROJECT_SUCCEEDED = 'REOPEN_PROJECT_SUCCEEDED'
export const FETCH_PROJECT_SURVEYS_SUCCEEDED = 'FETCH_PROJECT_SURVEYS_SUCCEEDED'
export const INIT_LAUNCH_SURVEYS_REQUESTED = 'INIT_LAUNCH_SURVEYS_REQUESTED'
export const INIT_CLOSE_SURVEYS_REQUESTED = 'INIT_CLOSE_SURVEYS_REQUESTED'
export const LAUNCH_SURVEYS_SUCCEEDED = 'LAUNCH_SURVEYS_SUCCEEDED'
export const CLOSE_SURVEYS_SUCCEEDED = 'CLOSE_SURVEYS_SUCCEEDED'
export const TOGGLE_CLOSE_WARNING_REQUESTED = 'TOGGLE_CLOSE_WARNING_REQUESTED'
export const EDIT_SAMPLE_SIZE_SUCCEEDED = 'EDIT_SAMPLE_SIZE_SUCCEEDED'
export const LAUNCH_SURVEYS_REQUESTED = 'LAUNCH_SURVEYS_REQUESTED'
export const CLOSE_SURVEYS_REQUESTED = 'CLOSE_SURVEYS_REQUESTED'